import { useState } from 'react';
import { useAuth } from '../AuthContext';
import api from '../api';

export default function ForcePasswordReset() {
  const { handleLogin } = useAuth();
  const [current, setCurrent] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPw !== confirm) return setError('Passwords do not match');
    setError('');
    setLoading(true);
    try {
      await api.changePassword(current, newPw);
      const user = await api.me();
      handleLogin(user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="force-reset-container">
      <div className="force-reset-card">
        <h2>Password Reset Required</h2>
        <p>Please set a new password to continue.</p>
        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label>Current Password</label>
            <input type="password" value={current} onChange={e => setCurrent(e.target.value)} required />
          </div>
          <div className="form-field">
            <label>New Password</label>
            <input type="password" value={newPw} onChange={e => setNewPw(e.target.value)} required />
          </div>
          <div className="form-field">
            <label>Confirm New Password</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
          </div>
          {error && <div className="form-error">{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Updating...' : 'Set Password'}
          </button>
        </form>
        <p className="form-hint">Minimum 8 characters with uppercase, lowercase, digit, and special character.</p>
      </div>
    </div>
  );
}
